module.exports = __webpack_public_path__ + "static/media/night.8d42391c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/night.mp4
// module id = 536
// module chunks = 8